module.exports = __webpack_public_path__ + "static/media/importacaoRegister.c29939e5.jpg";